import VisaUrl from "../../assets/cards/Visa.png";
import MastercardUrl from "../../assets/cards/Mastercard.png";
import AmexUrl from "../../assets/cards/Amex.png";
import DinersUrl from "../../assets/cards/Diners.png";
import DiscoverUrl from "../../assets/cards/Discover.png";
import MaestroUrl from "../../assets/cards/Maestro.png";

export const supportedCardTypes = [
  "visa",
  "mastercard",
  "maestro",
  "discover",
  "diners-club",
  "amex",
] as const;

export type CardType = (typeof supportedCardTypes)[number];

export const defaultCardTypes: CardType[] = ["visa", "mastercard", "maestro"];

export interface CardIssuer {
  type: CardType;
  pattern: RegExp;
  length: number[];
  cvvLength: number;
  imgSrc: string;
  altText: string;
}

const issuers: CardIssuer[] = [
  {
    type: "visa",
    pattern: /^4/,
    length: [13, 16, 19],
    cvvLength: 3,
    imgSrc: VisaUrl,
    altText: "Visa",
  },
  {
    type: "mastercard",
    pattern: /^(5[1-5])|^(2[2-7])/,
    length: [16],
    cvvLength: 3,
    imgSrc: MastercardUrl,
    altText: "Mastercard",
  },
  {
    type: "amex",
    pattern: /^3[47]/,
    length: [15],
    cvvLength: 4,
    imgSrc: AmexUrl,
    altText: "AMEX",
  },
  {
    type: "diners-club",
    pattern: /^(30[0-5]|309|36|38|39)/,
    length: [14, 16],
    cvvLength: 3,
    imgSrc: DinersUrl,
    altText: "Diners Club",
  },
  {
    type: "discover",
    pattern: /^(6011|64[4-9]|65)/,
    length: [16, 19],
    cvvLength: 3,
    imgSrc: DiscoverUrl,
    altText: "Discover Card",
  },
  {
    type: "maestro",
    pattern: /^(50|5[6-8]|6)/,
    length: [12, 13, 14, 15, 16, 17, 18, 19],
    cvvLength: 3,
    imgSrc: MaestroUrl,
    altText: "Maestro",
  },
];

export function getCardDescription(cardNumber: string): CardIssuer | undefined {
  return issuers.find((issuer) => issuer.pattern.test(cardNumber.replace(/\s/g, "")));
}

export function getCardDescriptionByType(cardType: string): CardIssuer | undefined {
  return issuers.find((issuer) => issuer.type === cardType);
}
